module.exports = __webpack_public_path__ + "img/up_res_info.64e0b527.svg";